import axios from "axios";
import { getGeo, isBot } from "./geo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const gid = (storage, key) => {
  let id = storage.getItem(key);
  if (!id) {
    id = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    storage.setItem(key, id);
  }
  return id;
};

export const getVisitorId = () => gid(localStorage, "ahjin_visitor_id");

const CHOICE_KEY = "ahjin_analytics_choice";
export const getAnalyticsChoice = () => localStorage.getItem(CHOICE_KEY);
export const setAnalyticsChoice = (v) => localStorage.setItem(CHOICE_KEY, v);

export const isInternalTraffic = () => {
  const h = window.location.hostname;
  if (h === "localhost" || h.endsWith("emergentagent.com") || h.endsWith("emergent.host")) return true;
  if (localStorage.getItem("ahjin_admin_device")) return true;
  if (isBot()) return true;
  return false;
};

export const trackEvent = (event, label = "") => {
  if (isInternalTraffic() || getAnalyticsChoice() === "no") return;
  getGeo()
    .then((geo) =>
      axios.post(`${API}/track`, {
        visitor_id: getVisitorId(),
        session_id: gid(sessionStorage, "ahjin_session_id"),
        path: window.location.pathname,
        event,
        label: label ? String(label).slice(0, 80) : null,
        country: geo.country,
        city: geo.city,
        region: geo.region,
      })
    )
    .catch(() => {});
};
